import React from 'react';
import { useBusiness } from '../../contexts/BusinessContext';

export default function PaymentSettings() {
  const { selectedBusiness: currentBusiness } = useBusiness();
  
  if (!currentBusiness) {
    return (
      <div className="p-6">
        <div className="bg-yellow-50 p-4 rounded-md">
          <h3 className="text-yellow-800 font-medium">Business Required</h3>
          <p className="text-yellow-700 mt-1">
            You need to create a business before setting up payments.
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="max-w-5xl mx-auto p-6">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Payment Settings</h1>
        <p className="mt-2 text-gray-600">
          Configure how you accept payments from your customers.
        </p>
      </header>
      
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Stripe Integration</h2>
          <p className="mt-1 text-sm text-gray-500">
            Status: Under Maintenance
          </p>
        </div>
        
        <div className="p-6">
          <div className="bg-blue-50 p-4 rounded-md">
            <h3 className="text-blue-800 font-medium">Stripe Integration is being rebuilt</h3>
            <p className="text-blue-700 mt-1">
              We're currently rebuilding our Stripe integration to provide a better payment experience.
              This functionality will be available again soon.
            </p>
            <p className="text-blue-700 mt-3 text-sm">
              If you need to process payments immediately, please contact support for alternative options.
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-8 bg-white rounded-lg shadow overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Payment Preferences</h2>
          <p className="mt-1 text-sm text-gray-500">
            Configure how payments are processed.
          </p>
        </div>
        
        <div className="p-6">
          <div className="bg-gray-50 p-4 rounded-md">
            <p className="text-gray-600">
              Payment preferences will be available once the Stripe integration is rebuilt.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
} 